import { engineSettings, persistSettings } from './engine'
import { createLogger } from 'yam-operator/util'

const log = createLogger('cli')

export async function downloadAndEnablePlugin(plugin: string): Promise<void> {
  let name = plugin.trim()
  let version = 'latest'
  if (plugin.indexOf(':') !== -1) {
    const tmp = plugin.split(':')
    name = tmp[0].trim()
    version = tmp[1].trim()
  }
  const existPlugin = engineSettings.plugins.find(p => p.name === name)
  if (existPlugin) {
    if (!existPlugin.enable) {
      existPlugin.enable = true
      persistSettings()
    }
  } else {
    // TODO find and download from yam.plus/p/org/plugin-name server, set real name/version
    const { ver, dir } = await downloadPluginOfVersion(name, version)
    engineSettings.plugins.push({
      name,
      version: ver,
      settings: {},
      builtIn: false,
      enable: true,
      directory: dir
    })
    persistSettings()
  }
}

export function disablePlugin(plugin: string): void {
  const existPlugin = engineSettings.plugins.find(p => p.name === plugin)
  if (existPlugin) {
    if (!existPlugin.enable) {
      existPlugin.enable = false
      persistSettings()
    }
  }
}

export async function updatePlugin(plugin: string, { version }: { version: string }): Promise<void> {
  const targetVer = version || 'latest'
  const existPlugin = engineSettings.plugins.find(p => p.name === plugin)
  if (existPlugin) {
    if (existPlugin.version === targetVer) {
      log.info('current plugin version is exactly the version you want.')
    } else {
      const { ver, dir } = await downloadPluginOfVersion(plugin, version)
      existPlugin.version = ver
      existPlugin.directory = dir
      persistSettings()
    }
  } else {
    throw new Error(`plugin ${plugin} doesn't exist, please enable it at first`)
  }
}

export async function publishPlugin(dir?: string): Promise<void> {
  // TODO
  // 1. package the plugin using npm script, name is "publisher/plugin-name"
  // 2. upload the tgz to the yam.plus or on-prem server, with login token
}

async function downloadPluginOfVersion(name: string, version: string): Promise<{ ver: string; dir: string }> {
  // TODO
  // 1. search and check the plugin version from cloud/hosted server
  // 2. download the target version package
  log.info(`start checking package of plugin ${name}, for version: ${version}`)
  return { ver: '1.0.0', dir: 'todo' }
}
